{
  "aws.access-analyzer-finding": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.account": {
    "columns": [
      {
        "type": "string",
        "field": "account_id",
        "headerName": "Id"
      }
    ],
    "id": "account_id"
  },
  "aws.acm-certificate": {
    "columns": [
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "array",
        "field": "SubjectAlternativeNames",
        "headerName": "Subject Alternative Names"
      },
      {
        "type": "string",
        "field": "Issuer",
        "headerName": "Issuer"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "NotAfter",
        "headerName": "Not After"
      },
      {
        "type": "array",
        "field": "InUseBy",
        "headerName": "In Use By"
      },
      {
        "type": "string",
        "field": "RenewalEligibility",
        "headerName": "Renewal Eligibility"
      },
      {
        "type": "time",
        "field": "CreatedAt",
        "headerName": "Created At",
        "hidden": true
      },
      {
        "type": "time",
        "field": "IssuedAt",
        "headerName": "Issued At",
        "hidden": true
      },
      {
        "type": "time",
        "field": "NotBefore",
        "headerName": "Not Before",
        "hidden": true
      }
    ],
    "id": "CertificateArn"
  },
  "aws.advisor-check": {
    "columns": [
      {
        "type": "string",
        "field": "checkId",
        "headerName": "Id"
      }
    ],
    "id": "checkId"
  },
  "aws.airflow": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.alarm": {
    "columns": [
      {
        "type": "string",
        "field": "AlarmName",
        "headerName": "Alarm Name"
      },
      {
        "type": "string",
        "field": "MetricName",
        "headerName": "Metric Name"
      },
      {
        "type": "string",
        "field": "StateValue",
        "headerName": "State Value"
      },
      {
        "type": "time",
        "field": "StateUpdatedTimestamp",
        "headerName": "State Updated Timestamp"
      },
      {
        "type": "boolean",
        "field": "ActionsEnabled",
        "headerName": "Actions Enabled"
      }
    ],
    "id": "AlarmName"
  },
  "aws.ami": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Image Id"
      },
      {
        "type": "string",
        "field": "ImageOwnerAlias",
        "headerName": "Image Owner Alias"
      },
      {
        "type": "string",
        "field": "Platform",
        "headerName": "Platform"
      },
      {
        "type": "string",
        "field": "CreationDate",
        "headerName": "Creation Date"
      },
      {
        "type": "boolean",
        "field": "Public",
        "headerName": "Public"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "boolean",
        "field": "BlockDeviceMappings[0].Ebs.Encrypted",
        "headerName": "Encrypted"
      },
      {
        "type": "string",
        "field": "ImageType",
        "headerName": "Image Type",
        "hidden": true
      },
      {
        "type": "boolean",
        "field": "EnaSupport",
        "headerName": "Ena Support",
        "hidden": true
      },
      {
        "type": "string",
        "field": "SriovNetSupport",
        "headerName": "Sriov Net Support",
        "hidden": true
      },
      {
        "type": "string",
        "field": "Description",
        "headerName": "Description",
        "hidden": true
      },
      {
        "type": "string",
        "field": "Hypervisor",
        "headerName": "Hypervisor",
        "hidden": true
      }
    ],
    "id": "ImageId"
  },
  "aws.apigw-domain-name": {
    "columns": [
      {
        "type": "string",
        "field": "domainName",
        "headerName": "Id"
      }
    ],
    "id": "domainName"
  },
  "aws.apigwv2": {
    "columns": [
      {
        "type": "string",
        "field": "ApiId",
        "headerName": "Id"
      }
    ],
    "id": "ApiId"
  },
  "aws.apigwv2-stage": {
    "columns": [
      {
        "type": "string",
        "field": "StageName",
        "headerName": "Id"
      }
    ],
    "id": "StageName"
  },
  "aws.app-elb": {
    "columns": [
      {
        "type": "string",
        "field": "LoadBalancerName",
        "headerName": "Load Balancer Name"
      },
      {
        "type": "string",
        "field": "DNSName",
        "headerName": "DNS Name"
      },
      {
        "type": "string",
        "field": "CanonicalHostedZoneId",
        "headerName": "Canonical Hosted Zone Id"
      },
      {
        "type": "string",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "Scheme",
        "headerName": "Scheme"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "State.Code",
        "headerName": "Code"
      }
    ],
    "id": "LoadBalancerArn"
  },
  "aws.app-elb-target-group": {
    "columns": [
      {
        "type": "string",
        "field": "TargetGroupName",
        "headerName": "Target Group Name"
      },
      {
        "type": "string",
        "field": "Protocol",
        "headerName": "Protocol"
      },
      {
        "type": "number",
        "field": "Port",
        "headerName": "Port"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "boolean",
        "field": "HealthCheckEnabled",
        "headerName": "Health Check Enabled"
      }
    ],
    "id": "TargetGroupArn"
  },
  "aws.app-flow": {
    "columns": [
      {
        "type": "string",
        "field": "flowName",
        "headerName": "Id"
      }
    ],
    "id": "flowName"
  },
  "aws.appdiscovery-agent": {
    "columns": [
      {
        "type": "string",
        "field": "agentId",
        "headerName": "Id"
      }
    ],
    "id": "agentId"
  },
  "aws.appmesh-mesh": {
    "columns": [
      {
        "type": "string",
        "field": "meshName",
        "headerName": "Id"
      }
    ],
    "id": "meshName"
  },
  "aws.appmesh-virtual-gateway": {
    "c7n-alias-for": "aws.appmesh-virtualgateway"
  },
  "aws.appmesh-virtualgateway": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.arn",
        "headerName": "Id"
      }
    ],
    "id": "metadata.arn"
  },
  "aws.appmesh-virtualnode": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.arn",
        "headerName": "Id"
      }
    ],
    "id": "metadata.arn"
  },
  "aws.appstream-fleet": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.appstream-stack": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.artifact-domain": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "owner",
        "headerName": "Owner"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "createdTime",
        "headerName": "Created Time"
      },
      {
        "type": "string",
        "field": "encryptionKey",
        "headerName": "Encryption Key"
      },
      {
        "type": "number",
        "field": "repositoryCount",
        "headerName": "Repository Count"
      }
    ],
    "id": "name"
  },
  "aws.artifact-repo": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "administratorAccount",
        "headerName": "Administrator Account"
      },
      {
        "type": "string",
        "field": "domainName",
        "headerName": "Domain Name"
      },
      {
        "type": "string",
        "field": "domainOwner",
        "headerName": "Domain Owner"
      }
    ],
    "id": "name"
  },
  "aws.asg": {
    "columns": [
      {
        "type": "string",
        "field": "AutoScalingGroupName",
        "headerName": "Auto Scaling Group Name"
      },
      {
        "type": "string",
        "field": "LaunchConfigurationName",
        "headerName": "Launch Configuration Name"
      },
      {
        "type": "number",
        "field": "MinSize",
        "headerName": "Min Size"
      },
      {
        "type": "number",
        "field": "MaxSize",
        "headerName": "Max Size"
      },
      {
        "type": "number",
        "field": "DesiredCapacity",
        "headerName": "Desired Capacity"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      }
    ],
    "id": "AutoScalingGroupName"
  },
  "aws.athena-capacity-reservation": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.athena-data-catalog": {
    "columns": [
      {
        "type": "string",
        "field": "CatalogName",
        "headerName": "Id"
      }
    ],
    "id": "CatalogName"
  },
  "aws.athena-named-query": {
    "columns": [
      {
        "type": "string",
        "field": "NamedQueryId",
        "headerName": "Id"
      }
    ],
    "id": "NamedQueryId"
  },
  "aws.athena-work-group": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.backup-plan": {
    "columns": [
      {
        "type": "string",
        "field": "BackupPlanName",
        "headerName": "Backup Plan Name"
      }
    ],
    "id": "BackupPlanName"
  },
  "aws.backup-vault": {
    "columns": [
      {
        "type": "string",
        "field": "BackupVaultName",
        "headerName": "Backup Vault Name"
      },
      {
        "type": "string",
        "field": "CreatorRequestId",
        "headerName": "Creator Request Id"
      },
      {
        "type": "time",
        "field": "CreationDate",
        "headerName": "Creation Date"
      },
      {
        "type": "string",
        "field": "EncryptionKeyArn",
        "headerName": "Encryption Key Arn"
      }
    ],
    "id": "BackupVaultName"
  },
  "aws.batch-compute": {
    "columns": [
      {
        "type": "string",
        "field": "computeEnvironmentName",
        "headerName": "Compute Environment Name"
      },
      {
        "type": "string",
        "field": "ecsClusterArn",
        "headerName": "Ecs Cluster Arn"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "computeResources.type",
        "headerName": "Compute Resource Type"
      }
    ],
    "id": "computeEnvironmentName"
  },
  "aws.batch-definition": {
    "columns": [
      {
        "type": "string",
        "field": "jobDefinitionName",
        "headerName": "Job Definition Name"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "boolean",
        "field": "containerProperties.readonlyRootFilesystem",
        "headerName": "Readonly Root Filesystem"
      },
      {
        "type": "string",
        "field": "containerProperties.user",
        "headerName": "User"
      },
      {
        "type": "boolean",
        "field": "containerProperties.privileged",
        "headerName": "Privileged container"
      }
    ],
    "id": "jobDefinitionName"
  },
  "aws.batch-queue": {
    "columns": [
      {
        "type": "string",
        "field": "jobQueueName",
        "headerName": "Id"
      }
    ],
    "id": "jobQueueName"
  },
  "aws.bedrock-agent": {
    "columns": [
      {
        "type": "string",
        "field": "agentId",
        "headerName": "Id"
      }
    ],
    "id": "agentId"
  },
  "aws.bedrock-custom-model": {
    "columns": [
      {
        "type": "string",
        "field": "modelArn",
        "headerName": "Id"
      }
    ],
    "id": "modelArn"
  },
  "aws.bedrock-customization-job": {
    "columns": [
      {
        "type": "string",
        "field": "jobArn",
        "headerName": "Id"
      }
    ],
    "id": "jobArn"
  },
  "aws.bedrock-foundation-model": {
    "columns": [
      {
        "type": "string",
        "field": "modelId",
        "headerName": "Id"
      }
    ],
    "id": "modelId"
  },
  "aws.bedrock-guardrail": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.bedrock-inference-profile": {
    "columns": [
      {
        "type": "string",
        "field": "inferenceProfileArn",
        "headerName": "Id"
      }
    ],
    "id": "inferenceProfileArn"
  },
  "aws.bedrock-knowledge-base": {
    "columns": [
      {
        "type": "string",
        "field": "knowledgeBaseId",
        "headerName": "Id"
      }
    ],
    "id": "knowledgeBaseId"
  },
  "aws.bedrock-model-invocation-job": {
    "columns": [
      {
        "type": "string",
        "field": "jobArn",
        "headerName": "Id"
      }
    ],
    "id": "jobArn"
  },
  "aws.budget": {
    "columns": [
      {
        "type": "string",
        "field": "BudgetName",
        "headerName": "Id"
      }
    ],
    "id": "BudgetName"
  },
  "aws.cache-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "CacheClusterId",
        "headerName": "Cache Cluster Id"
      },
      {
        "type": "time",
        "field": "CacheClusterCreateTime",
        "headerName": "Cache Cluster Create Time"
      },
      {
        "type": "string",
        "field": "CacheClusterStatus",
        "headerName": "Cache Cluster Status"
      },
      {
        "type": "string",
        "field": "Engine",
        "headerName": "Engine"
      },
      {
        "type": "string",
        "field": "EngineVersion",
        "headerName": "Engine Version"
      },
      {
        "type": "number",
        "field": "NumCacheNodes",
        "headerName": "Num Cache Nodes"
      }
    ],
    "id": "CacheClusterId"
  },
  "aws.cache-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "SnapshotName",
        "headerName": "Snapshot Name"
      },
      {
        "type": "string",
        "field": "CacheClusterId",
        "headerName": "Cache Cluster Id"
      },
      {
        "type": "string",
        "field": "SnapshotSource",
        "headerName": "Snapshot Source"
      }
    ],
    "id": "SnapshotName"
  },
  "aws.cache-subnet-group": {
    "columns": [
      {
        "type": "string",
        "field": "CacheSubnetGroupName",
        "headerName": "Cache Subnet Group Name"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      }
    ],
    "id": "CacheSubnetGroupName"
  },
  "aws.catalog-portfolio": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.catalog-product": {
    "columns": [
      {
        "type": "string",
        "field": "ProductId",
        "headerName": "Id"
      }
    ],
    "id": "ProductId"
  },
  "aws.cfn": {
    "columns": [
      {
        "type": "string",
        "field": "StackName",
        "headerName": "Stack Name"
      },
      {
        "type": "string",
        "field": "StackId",
        "headerName": "Stack Id"
      },
      {
        "type": "string",
        "field": "StackStatus",
        "headerName": "Stack Status"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "time",
        "field": "LastUpdatedTime",
        "headerName": "Last Updated Time"
      },
      {
        "type": "array",
        "field": "Capabilities",
        "headerName": "Capabilities"
      },
      {
        "type": "boolean",
        "field": "EnableTerminationProtection",
        "headerName": "Enable Termination Protection"
      },
      {
        "type": "string",
        "field": "DriftInformation.StackDriftStatus",
        "headerName": "Stack Drift Status"
      }
    ],
    "id": "StackName"
  },
  "aws.cleanrooms-collaboration": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.cleanrooms-collaboration-member": {
    "columns": [
      {
        "type": "string",
        "field": "accountId",
        "headerName": "Id"
      }
    ],
    "id": "accountId"
  },
  "aws.cleanrooms-configured-table": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.cleanrooms-membership": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.client-vpn-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "ClientVpnEndpointId",
        "headerName": "Id"
      }
    ],
    "id": "ClientVpnEndpointId"
  },
  "aws.cloud-directory": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreationDateTime",
        "headerName": "Creation Date Time"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      }
    ],
    "id": "DirectoryArn"
  },
  "aws.cloudfront-function": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.cloudfront-key-value-store": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.cloudhsm-backup": {
    "columns": [
      {
        "type": "string",
        "field": "BackupId",
        "headerName": "Id"
      }
    ],
    "id": "BackupId"
  },
  "aws.cloudhsm-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterId",
        "headerName": "Cluster Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "time",
        "field": "CreateTimestamp",
        "headerName": "Create Timestamp"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "BackupPolicy",
        "headerName": "Backup Policy"
      },
      {
        "type": "string",
        "field": "HsmType",
        "headerName": "Hsm Type"
      }
    ],
    "id": "ClusterId"
  },
  "aws.cloudsearch": {
    "columns": [
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "boolean",
        "field": "Created",
        "headerName": "Created"
      },
      {
        "type": "boolean",
        "field": "Deleted",
        "headerName": "Deleted"
      },
      {
        "type": "string",
        "field": "SearchInstanceType",
        "headerName": "Search Instance Type"
      },
      {
        "type": "number",
        "field": "SearchInstanceCount",
        "headerName": "Search Instance Count"
      },
      {
        "type": "boolean",
        "field": "RequiresIndexDocuments",
        "headerName": "Requires Index Documents"
      },
      {
        "type": "boolean",
        "field": "Processing",
        "headerName": "Processing"
      }
    ],
    "id": "DomainName"
  },
  "aws.cloudtrail": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "S3BucketName",
        "headerName": "S3 Bucket Name"
      },
      {
        "type": "boolean",
        "field": "IncludeGlobalServiceEvents",
        "headerName": "Include Global Service Events"
      },
      {
        "type": "boolean",
        "field": "IsMultiRegionTrail",
        "headerName": "Is Multi Region Trail"
      },
      {
        "type": "boolean",
        "field": "LogFileValidationEnabled",
        "headerName": "Log File Validation Enabled"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "string",
        "field": "HomeRegion",
        "headerName": "Home Region"
      },
      {
        "type": "boolean",
        "field": "IsOrganizationTrail",
        "headerName": "Is Organization Trail"
      }
    ],
    "id": "TrailARN"
  },
  "aws.cloudwatch-dashboard": {
    "columns": [
      {
        "type": "string",
        "field": "DashboardName",
        "headerName": "Id"
      }
    ],
    "id": "DashboardName"
  },
  "aws.cloudwatch-synthetics": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.codebuild": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "encryptionKey",
        "headerName": "Encryption Key"
      },
      {
        "type": "time",
        "field": "created",
        "headerName": "Created"
      },
      {
        "type": "time",
        "field": "lastModified",
        "headerName": "Last Modified"
      },
      {
        "type": "boolean",
        "field": "environment.privilegedMode",
        "headerName": "Privileged Mode"
      },
      {
        "type": "string",
        "field": "vpcConfig.vpcId",
        "headerName": "Vpc Id"
      }
    ],
    "id": "name"
  },
  "aws.codebuild-credential": {
    "columns": [
      {
        "type": "string",
        "field": "arn",
        "headerName": "Id"
      }
    ],
    "id": "arn"
  },
  "aws.codecommit": {
    "columns": [
      {
        "type": "string",
        "field": "repositoryName",
        "headerName": "Repository Name"
      },
      {
        "type": "string",
        "field": "repositoryId",
        "headerName": "Repository Id"
      },
      {
        "type": "string",
        "field": "defaultBranch",
        "headerName": "Default Branch"
      },
      {
        "type": "time",
        "field": "lastModifiedDate",
        "headerName": "Last Modified Date"
      },
      {
        "type": "time",
        "field": "creationDate",
        "headerName": "Creation Date"
      }
    ],
    "id": "repositoryName"
  },
  "aws.codedeploy-app": {
    "columns": [
      {
        "type": "string",
        "field": "applicationName",
        "headerName": "Id"
      }
    ],
    "id": "applicationName"
  },
  "aws.codedeploy-config": {
    "columns": [
      {
        "type": "string",
        "field": "deploymentConfigId",
        "headerName": "Id"
      }
    ],
    "id": "deploymentConfigId"
  },
  "aws.codedeploy-deployment": {
    "columns": [
      {
        "type": "string",
        "field": "deploymentId",
        "headerName": "Id"
      }
    ],
    "id": "deploymentId"
  },
  "aws.codedeploy-group": {
    "columns": [
      {
        "type": "string",
        "field": "deploymentGroupId",
        "headerName": "Id"
      }
    ],
    "id": "deploymentGroupId"
  },
  "aws.codepipeline": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "name"
  },
  "aws.composite-alarm": {
    "columns": [
      {
        "type": "string",
        "field": "AlarmName",
        "headerName": "Id"
      }
    ],
    "id": "AlarmName"
  },
  "aws.comprehend-document-classification-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-document-classifier": {
    "columns": [
      {
        "type": "string",
        "field": "DocumentClassifierArn",
        "headerName": "Id"
      }
    ],
    "id": "DocumentClassifierArn"
  },
  "aws.comprehend-dominant-language-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "EndpointArn",
        "headerName": "Id"
      }
    ],
    "id": "EndpointArn"
  },
  "aws.comprehend-entities-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-entity-recognizer": {
    "columns": [
      {
        "type": "string",
        "field": "EntityRecognizerArn",
        "headerName": "Id"
      }
    ],
    "id": "EntityRecognizerArn"
  },
  "aws.comprehend-events-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-flywheel": {
    "columns": [
      {
        "type": "string",
        "field": "FlywheelArn",
        "headerName": "Id"
      }
    ],
    "id": "FlywheelArn"
  },
  "aws.comprehend-key-phrases-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-pii-entities-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-sentiment-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-targeted-sentiment-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.comprehend-topics-detection-job": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.config-recorder": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "boolean",
        "field": "recordingGroup.allSupported",
        "headerName": "All Supported"
      },
      {
        "type": "boolean",
        "field": "recordingGroup.includeGlobalResourceTypes",
        "headerName": "Include Global Resource Types"
      }
    ],
    "id": "name"
  },
  "aws.config-rule": {
    "columns": [
      {
        "type": "string",
        "field": "ConfigRuleName",
        "headerName": "Config Rule Name"
      },
      {
        "type": "string",
        "field": "ConfigRuleId",
        "headerName": "Config Rule Id"
      },
      {
        "type": "string",
        "field": "ConfigRuleState",
        "headerName": "Config Rule State"
      },
      {
        "type": "string",
        "field": "CreatedBy",
        "headerName": "Created By"
      },
      {
        "type": "string",
        "field": "Source.Owner",
        "headerName": "Owner"
      },
      {
        "type": "string",
        "field": "Source.SourceIdentifier",
        "headerName": "Source Identifier"
      }
    ],
    "id": "ConfigRuleName"
  },
  "aws.connect-campaign": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.connect-instance": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.customer-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "DeviceName",
        "headerName": "Device Name"
      },
      {
        "type": "string",
        "field": "CustomerGatewayId",
        "headerName": "Customer Gateway Id"
      },
      {
        "type": "string",
        "field": "IpAddress",
        "headerName": "Ip Address"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "BgpAsn",
        "headerName": "Bgp Asn"
      }
    ],
    "id": "CustomerGatewayId"
  },
  "aws.datalake-location": {
    "columns": [
      {
        "type": "string",
        "field": "ResourceArn",
        "headerName": "Id"
      }
    ],
    "id": "ResourceArn"
  },
  "aws.datapipeline": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "pipelineId",
        "headerName": "Pipeline Id"
      }
    ],
    "id": "pipelineId"
  },
  "aws.datasync-agent": {
    "columns": [
      {
        "type": "string",
        "field": "AgentArn",
        "headerName": "Id"
      }
    ],
    "id": "AgentArn"
  },
  "aws.datasync-task": {
    "columns": [
      {
        "type": "string",
        "field": "TaskArn",
        "headerName": "Id"
      }
    ],
    "id": "TaskArn"
  },
  "aws.dax": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterName",
        "headerName": "Cluster Name"
      },
      {
        "type": "number",
        "field": "TotalNodes",
        "headerName": "Total Nodes"
      },
      {
        "type": "number",
        "field": "ActiveNodes",
        "headerName": "Active Nodes"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      }
    ],
    "id": "ClusterName"
  },
  "aws.delivery-destination": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Id"
      }
    ],
    "id": "name"
  },
  "aws.destination": {
    "columns": [
      {
        "type": "string",
        "field": "destinationName",
        "headerName": "Id"
      }
    ],
    "id": "destinationName"
  },
  "aws.devicefarm-project": {
    "columns": [
      {
        "type": "string",
        "field": "arn",
        "headerName": "Id"
      }
    ],
    "id": "arn"
  },
  "aws.devops-agent-space": {
    "columns": [
      {
        "type": "string",
        "field": "agentSpaceId",
        "headerName": "Id"
      }
    ],
    "id": "agentSpaceId"
  },
  "aws.directconnect": {
    "columns": [
      {
        "type": "string",
        "field": "connectionName",
        "headerName": "Connection Name"
      },
      {
        "type": "string",
        "field": "connectionId",
        "headerName": "Connection Id"
      },
      {
        "type": "string",
        "field": "connectionState",
        "headerName": "Connection State"
      },
      {
        "type": "string",
        "field": "ownerAccount",
        "headerName": "Owner Account"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "awsDeviceV2",
        "headerName": "Aws Device V2"
      },
      {
        "type": "string",
        "field": "hasLogicalRedundancy",
        "headerName": "Has Logical Redundancy"
      },
      {
        "type": "string",
        "field": "partnerName",
        "headerName": "Partner Name"
      },
      {
        "type": "string",
        "field": "providerName",
        "headerName": "Provider Name"
      }
    ],
    "id": "connectionId"
  },
  "aws.directconnect-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "directConnectGatewayId",
        "headerName": "Id"
      }
    ],
    "id": "directConnectGatewayId"
  },
  "aws.directconnect-virtual-interface": {
    "columns": [
      {
        "type": "string",
        "field": "virtualInterfaceId",
        "headerName": "Id"
      }
    ],
    "id": "virtualInterfaceId"
  },
  "aws.directory": {
    "columns": [
      {
        "type": "string",
        "field": "DirectoryId",
        "headerName": "Directory Id"
      },
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "Alias",
        "headerName": "Alias"
      },
      {
        "type": "string",
        "field": "ShareStatus",
        "headerName": "Share Status"
      },
      {
        "type": "string",
        "field": "VpcSettings.VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "Stage",
        "headerName": "Stage"
      },
      {
        "type": "boolean",
        "field": "SsoEnabled",
        "headerName": "Sso Enabled"
      }
    ],
    "id": "DirectoryId"
  },
  "aws.distribution": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "boolean",
        "field": "Enabled",
        "headerName": "Enabled"
      },
      {
        "type": "string",
        "field": "DefaultCacheBehavior.ViewerProtocolPolicy",
        "headerName": "Viewer Protocol Policy"
      },
      {
        "type": "time",
        "field": "LastModifiedTime",
        "headerName": "Last Modified Time"
      },
      {
        "type": "string",
        "field": "PriceClass",
        "headerName": "Price Class"
      },
      {
        "type": "string",
        "field": "Restrictions.GeoRestriction.RestrictionType",
        "headerName": "Restriction Type"
      },
      {
        "type": "string",
        "field": "WebACLId",
        "headerName": "Web ACL Id"
      }
    ],
    "id": "Id"
  },
  "aws.dlm-policy": {
    "columns": [
      {
        "type": "string",
        "field": "PolicyId",
        "headerName": "Policy Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "time",
        "field": "DateCreated",
        "headerName": "Date Created"
      },
      {
        "type": "time",
        "field": "DateModified",
        "headerName": "Date Modified"
      }
    ],
    "id": "PolicyId"
  },
  "aws.dms-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "EndpointIdentifier",
        "headerName": "Endpoint Identifier"
      },
      {
        "type": "string",
        "field": "EndpointType",
        "headerName": "Endpoint Type"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "EngineName",
        "headerName": "Engine Name"
      },
      {
        "type": "string",
        "field": "ServerName",
        "headerName": "Server Name"
      },
      {
        "type": "string",
        "field": "DatabaseName",
        "headerName": "Database Name"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "string",
        "field": "SslMode",
        "headerName": "Ssl Mode"
      }
    ],
    "id": "EndpointArn"
  },
  "aws.dms-instance": {
    "columns": [
      {
        "type": "string",
        "field": "ReplicationInstanceIdentifier",
        "headerName": "Replication Instance Identifier"
      },
      {
        "type": "string",
        "field": "ReplicationInstanceClass",
        "headerName": "Replication Instance Class"
      },
      {
        "type": "boolean",
        "field": "PubliclyAccessible",
        "headerName": "Publicly Accessible"
      },
      {
        "type": "boolean",
        "field": "MultiAZ",
        "headerName": "Multi AZ"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "string",
        "field": "ReplicationSubnetGroup.VpcId",
        "headerName": "Vpc Id"
      }
    ],
    "id": "ReplicationInstanceIdentifier"
  },
  "aws.dms-replication-task": {
    "columns": [
      {
        "type": "string",
        "field": "ReplicationTaskArn",
        "headerName": "Id"
      }
    ],
    "id": "ReplicationTaskArn"
  },
  "aws.dsql-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "identifier",
        "headerName": "Id"
      }
    ],
    "id": "identifier"
  },
  "aws.dsql-stream": {
    "columns": [
      {
        "type": "string",
        "field": "streamIdentifier",
        "headerName": "Id"
      }
    ],
    "id": "streamIdentifier"
  },
  "aws.dynamodb-backup": {
    "columns": [
      {
        "type": "string",
        "field": "TableName",
        "headerName": "Table Name"
      },
      {
        "type": "string",
        "field": "TableId",
        "headerName": "Table Id"
      },
      {
        "type": "string",
        "field": "BackupName",
        "headerName": "Backup Name"
      },
      {
        "type": "time",
        "field": "BackupCreationDateTime",
        "headerName": "Backup Creation Date Time"
      },
      {
        "type": "string",
        "field": "BackupStatus",
        "headerName": "Backup Status"
      },
      {
        "type": "string",
        "field": "BackupType",
        "headerName": "Backup Type"
      },
      {
        "type": "number",
        "field": "BackupSizeBytes",
        "headerName": "Backup Size Bytes"
      }
    ],
    "id": "BackupArn"
  },
  "aws.dynamodb-stream": {
    "columns": [
      {
        "type": "string",
        "field": "TableName",
        "headerName": "Table Name"
      },
      {
        "type": "string",
        "field": "StreamViewType",
        "headerName": "Stream View Type"
      },
      {
        "type": "time",
        "field": "CreationRequestDateTime",
        "headerName": "Creation Request Date Time"
      },
      {
        "type": "string",
        "field": "StreamArn",
        "headerName": "Stream Arn"
      }
    ],
    "id": "StreamArn"
  },
  "aws.dynamodb-table": {
    "columns": [
      {
        "type": "string",
        "field": "TableName",
        "headerName": "Table Name"
      },
      {
        "type": "string",
        "field": "TableId",
        "headerName": "Table Id"
      },
      {
        "type": "time",
        "field": "CreationDateTime",
        "headerName": "Creation Date Time"
      },
      {
        "type": "string",
        "field": "TableStatus",
        "headerName": "Table Status"
      },
      {
        "type": "number",
        "field": "TableSizeBytes",
        "headerName": "Table Size Bytes"
      },
      {
        "type": "string",
        "field": "BillingModeSummary.BillingMode",
        "headerName": "Billing Mode"
      },
      {
        "type": "boolean",
        "field": "StreamSpecification.StreamEnabled",
        "headerName": "Stream Enabled"
      }
    ],
    "id": "TableName"
  },
  "aws.ebs": {
    "columns": [
      {
        "type": "string",
        "field": "VolumeId",
        "headerName": "Volume Id"
      },
      {
        "type": "number",
        "field": "Size",
        "headerName": "Size"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "boolean",
        "field": "Encrypted",
        "headerName": "Encrypted"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "VolumeType",
        "headerName": "Volume Type"
      }
    ],
    "id": "VolumeId"
  },
  "aws.ebs-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "SnapshotId",
        "headerName": "Snapshot Id"
      },
      {
        "type": "boolean",
        "field": "Encrypted",
        "headerName": "Encrypted"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "VolumeId",
        "headerName": "Volume Id"
      },
      {
        "type": "string",
        "field": "OwnerAlias",
        "headerName": "Owner Alias"
      },
      {
        "type": "time",
        "field": "StartTime",
        "headerName": "Start Time"
      }
    ],
    "id": "SnapshotId"
  },
  "aws.ec2": {
    "columns": [
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance Id"
      },
      {
        "type": "string",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "string",
        "field": "Tags[?Key=='Name'].Value",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Image Id"
      },
      {
        "type": "string",
        "field": "PrivateIpAddress",
        "headerName": "Private Ip Address"
      },
      {
        "type": "time",
        "field": "LaunchTime",
        "headerName": "Launch Time"
      },
      {
        "type": "string",
        "field": "KeyName",
        "headerName": "Key Name"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "SubnetId",
        "headerName": "Subnet Id"
      },
      {
        "type": "string",
        "field": "State.Name",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "IamInstanceProfile.Id",
        "headerName": "IAM Instance Profile"
      }
    ],
    "id": "InstanceId"
  },
  "aws.ec2-capacity-reservation": {
    "columns": [
      {
        "type": "string",
        "field": "CapacityReservationId",
        "headerName": "Id"
      }
    ],
    "id": "CapacityReservationId"
  },
  "aws.ec2-host": {
    "columns": [
      {
        "type": "string",
        "field": "HostId",
        "headerName": "Id"
      }
    ],
    "id": "HostId"
  },
  "aws.ec2-instance-ami": {
    "columns": [
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Id"
      }
    ],
    "id": "InstanceId"
  },
  "aws.ec2-reserved": {
    "columns": [
      {
        "type": "time",
        "field": "Start",
        "headerName": "Start"
      },
      {
        "type": "time",
        "field": "End",
        "headerName": "End"
      },
      {
        "type": "string",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "number",
        "field": "InstanceCount",
        "headerName": "Instance Count"
      },
      {
        "type": "string",
        "field": "Scope",
        "headerName": "Scope"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      }
    ],
    "id": "ReservedInstancesId"
  },
  "aws.ec2-spot-fleet-request": {
    "columns": [
      {
        "type": "string",
        "field": "SpotFleetRequestId",
        "headerName": "Id"
      }
    ],
    "id": "SpotFleetRequestId"
  },
  "aws.ecr": {
    "columns": [
      {
        "type": "string",
        "field": "registryId",
        "headerName": "Registry Id"
      },
      {
        "type": "string",
        "field": "repositoryName",
        "headerName": "Repository Name"
      },
      {
        "type": "time",
        "field": "createdAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "encryptionConfiguration.encryptionType",
        "headerName": "Encryption Type"
      },
      {
        "type": "string",
        "field": "encryptionConfiguration.kmsKey",
        "headerName": "Kms Key"
      }
    ],
    "id": "repositoryName"
  },
  "aws.ecr-image": {
    "columns": [
      {
        "type": "string",
        "field": "imageDigest",
        "headerName": "Id"
      }
    ],
    "id": "imageDigest"
  },
  "aws.ecs": {
    "columns": [
      {
        "type": "string",
        "field": "clusterName",
        "headerName": "Cluster Name"
      },
      {
        "type": "string",
        "field": "clusterArn",
        "headerName": "Cluster Arn"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "number",
        "field": "registeredContainerInstancesCount",
        "headerName": "Registered Container Instances Count"
      },
      {
        "type": "number",
        "field": "runningTasksCount",
        "headerName": "Running Tasks Count"
      },
      {
        "type": "number",
        "field": "activeServicesCount",
        "headerName": "Active Services Count"
      }
    ],
    "id": "clusterArn"
  },
  "aws.ecs-container-instance": {
    "columns": [
      {
        "type": "string",
        "field": "ec2InstanceId",
        "headerName": "Ec2 Instance Id"
      },
      {
        "type": "string",
        "field": "versionInfo.dockerVersion",
        "headerName": "Docker Version"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "registeredAt",
        "headerName": "Registered At"
      }
    ],
    "id": "containerInstanceArn"
  },
  "aws.ecs-service": {
    "columns": [
      {
        "type": "string",
        "field": "serviceName",
        "headerName": "Service Name"
      },
      {
        "type": "string",
        "field": "clusterArn",
        "headerName": "Cluster Arn"
      },
      {
        "type": "string",
        "field": "launchType",
        "headerName": "Launch Type"
      },
      {
        "type": "string",
        "field": "taskDefinition",
        "headerName": "Task Definition"
      },
      {
        "type": "time",
        "field": "createdAt",
        "headerName": "Created At"
      },
      {
        "type": "boolean",
        "field": "enableECSManagedTags",
        "headerName": "Enable ECS Managed Tags"
      },
      {
        "type": "string",
        "field": "propagateTags",
        "headerName": "Propagate Tags"
      }
    ],
    "id": "serviceArn"
  },
  "aws.ecs-task": {
    "columns": [
      {
        "type": "string",
        "field": "taskArn",
        "headerName": "Task Arn"
      },
      {
        "type": "string",
        "field": "taskDefinitionArn",
        "headerName": "Task Definition Arn"
      },
      {
        "type": "string",
        "field": "clusterArn",
        "headerName": "Cluster Arn"
      },
      {
        "type": "string",
        "field": "connectivity",
        "headerName": "Connectivity"
      },
      {
        "type": "time",
        "field": "createdAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "group",
        "headerName": "Group"
      },
      {
        "type": "string",
        "field": "launchType",
        "headerName": "Launch Type"
      },
      {
        "type": "number",
        "field": "version",
        "headerName": "Version"
      },
      {
        "type": "array",
        "field": "containers",
        "headerName": "Containers"
      }
    ],
    "id": "taskArn"
  },
  "aws.ecs-task-definition": {
    "columns": [
      {
        "type": "string",
        "field": "taskDefinitionArn",
        "headerName": "Task Definition Arn"
      },
      {
        "type": "string",
        "field": "family",
        "headerName": "Family"
      },
      {
        "type": "string",
        "field": "networkMode",
        "headerName": "Network Mode"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      }
    ],
    "id": "taskDefinitionArn"
  },
  "aws.efs": {
    "columns": [
      {
        "type": "string",
        "field": "CreationToken",
        "headerName": "Creation Token"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "FileSystemId",
        "headerName": "File System Id"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      },
      {
        "type": "string",
        "field": "PerformanceMode",
        "headerName": "Performance Mode"
      },
      {
        "type": "boolean",
        "field": "Encrypted",
        "headerName": "Encrypted"
      }
    ],
    "id": "FileSystemId"
  },
  "aws.efs-mount-target": {
    "columns": [
      {
        "type": "string",
        "field": "MountTargetId",
        "headerName": "Mount Target Id"
      },
      {
        "type": "string",
        "field": "FileSystemId",
        "headerName": "File System Id"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      },
      {
        "type": "string",
        "field": "LifeCycleState",
        "headerName": "Life Cycle State"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      }
    ],
    "id": "MountTargetId"
  },
  "aws.eks": {
    "columns": [
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "endpoint",
        "headerName": "Endpoint"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "resourcesVpcConfig.vpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "boolean",
        "field": "resourcesVpcConfig.endpointPublicAccess",
        "headerName": "Endpoint Public Access"
      },
      {
        "type": "string",
        "field": "roleArn",
        "headerName": "Role Arn"
      },
      {
        "type": "string",
        "field": "version",
        "headerName": "Version"
      },
      {
        "type": "time",
        "field": "createdAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "platformVersion",
        "headerName": "Platform Version"
      }
    ],
    "id": "name"
  },
  "aws.eks-nodegroup": {
    "columns": [
      {
        "type": "string",
        "field": "nodegroupArn",
        "headerName": "Id"
      }
    ],
    "id": "nodegroupArn"
  },
  "aws.elastic-ip": {
    "columns": [
      {
        "type": "string",
        "field": "PublicIp",
        "headerName": "Public Ip"
      },
      {
        "type": "string",
        "field": "PrivateIpAddress",
        "headerName": "Private Ip Address"
      },
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance Id"
      },
      {
        "type": "string",
        "field": "AllocationId",
        "headerName": "Allocation Id"
      },
      {
        "type": "string",
        "field": "AssociationId",
        "headerName": "Association Id"
      },
      {
        "type": "string",
        "field": "PublicIpv4Pool",
        "headerName": "Public Ipv4 Pool"
      }
    ],
    "id": "AllocationId"
  },
  "aws.elasticache-group": {
    "columns": [
      {
        "type": "string",
        "field": "ReplicationGroupId",
        "headerName": "Replication Group Id"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "MultiAZ",
        "headerName": "Multi AZ"
      },
      {
        "type": "string",
        "field": "AutomaticFailover",
        "headerName": "Automatic Failover"
      },
      {
        "type": "boolean",
        "field": "ClusterEnabled",
        "headerName": "Cluster Enabled"
      },
      {
        "type": "boolean",
        "field": "TransitEncryptionEnabled",
        "headerName": "Transit Encryption Enabled"
      },
      {
        "type": "boolean",
        "field": "AtRestEncryptionEnabled",
        "headerName": "At Rest Encryption Enabled"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      }
    ],
    "id": "ReplicationGroupId"
  },
  "aws.elasticache-reserved": {
    "columns": [
      {
        "type": "string",
        "field": "ReservedCacheNodeId",
        "headerName": "Id"
      }
    ],
    "id": "ReservedCacheNodeId"
  },
  "aws.elasticache-user": {
    "columns": [
      {
        "type": "string",
        "field": "UserId",
        "headerName": "Id"
      }
    ],
    "id": "UserId"
  },
  "aws.elasticbeanstalk": {
    "columns": [
      {
        "type": "string",
        "field": "ApplicationName",
        "headerName": "Application Name"
      },
      {
        "type": "time",
        "field": "DateCreated",
        "headerName": "Date Created"
      },
      {
        "type": "time",
        "field": "DateUpdated",
        "headerName": "Date Updated"
      }
    ],
    "id": "ApplicationName"
  },
  "aws.elasticbeanstalk-environment": {
    "columns": [
      {
        "type": "string",
        "field": "EnvironmentName",
        "headerName": "Environment Name"
      },
      {
        "type": "string",
        "field": "EnvironmentId",
        "headerName": "Environment Id"
      },
      {
        "type": "string",
        "field": "ApplicationName",
        "headerName": "Application Name"
      },
      {
        "type": "time",
        "field": "DateCreated",
        "headerName": "Date Created"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "Health",
        "headerName": "Health"
      },
      {
        "type": "string",
        "field": "HealthStatus",
        "headerName": "Health Status"
      }
    ],
    "id": "EnvironmentName"
  },
  "aws.elasticsearch": {
    "columns": [
      {
        "type": "string",
        "field": "DomainId",
        "headerName": "Domain Id"
      },
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "boolean",
        "field": "Created",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "ElasticsearchVersion",
        "headerName": "Elasticsearch Version"
      },
      {
        "type": "string",
        "field": "ElasticsearchClusterConfig.InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "number",
        "field": "ElasticsearchClusterConfig.InstanceCount",
        "headerName": "Instance Count"
      },
      {
        "type": "string",
        "field": "VPCOptions.VPCId",
        "headerName": "VPC Id"
      },
      {
        "type": "boolean",
        "field": "CognitoOptions.Enabled",
        "headerName": "Cognito Enabled"
      },
      {
        "type": "boolean",
        "field": "EncryptionAtRestOptions.Enabled",
        "headerName": "Encryption at Rest Enabled"
      },
      {
        "type": "string",
        "field": "EncryptionAtRestOptions.KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "boolean",
        "field": "NodeToNodeEncryptionOptions.Enabled",
        "headerName": "Node to Node Encryption Enabled"
      },
      {
        "type": "boolean",
        "field": "DomainEndpointOptions.EnforceHTTPS",
        "headerName": "Enforce HTTPS"
      },
      {
        "type": "boolean",
        "field": "AdvancedSecurityOptions.Enabled",
        "headerName": "Advanced Security Enabled"
      },
      {
        "type": "boolean",
        "field": "AdvancedSecurityOptions.SAMLOptions.Enabled",
        "headerName": "SAML Enabled"
      }
    ],
    "id": "DomainName"
  },
  "aws.elasticsearch-reserved": {
    "columns": [
      {
        "type": "string",
        "field": "ReservationName",
        "headerName": "Reservation Name"
      },
      {
        "type": "string",
        "field": "ReservedElasticsearchInstanceId",
        "headerName": "Reserved Elasticsearch Instance Id"
      },
      {
        "type": "string",
        "field": "ElasticsearchInstanceType",
        "headerName": "Elasticsearch Instance Type"
      },
      {
        "type": "time",
        "field": "StartTime",
        "headerName": "Start Time"
      },
      {
        "type": "number",
        "field": "Duration",
        "headerName": "Duration"
      },
      {
        "type": "number",
        "field": "ElasticsearchInstanceCount",
        "headerName": "Elasticsearch Instance Count"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      }
    ],
    "id": "ReservedElasticsearchInstanceId"
  },
  "aws.elb": {
    "columns": [
      {
        "type": "string",
        "field": "LoadBalancerName",
        "headerName": "Load Balancer Name"
      },
      {
        "type": "string",
        "field": "DNSName",
        "headerName": "DNS Name"
      },
      {
        "type": "string",
        "field": "VPCId",
        "headerName": "VPC Id"
      },
      {
        "type": "string",
        "field": "Scheme",
        "headerName": "Scheme"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      }
    ],
    "id": "LoadBalancerName"
  },
  "aws.emr": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.emr-security-configuration": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.emr-serverless-app": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.eni": {
    "columns": [
      {
        "type": "string",
        "field": "NetworkInterfaceId",
        "headerName": "Network Interface Id"
      },
      {
        "type": "string",
        "field": "Association.AllocationId",
        "headerName": "Allocation Id"
      },
      {
        "type": "string",
        "field": "Association.AssociationId",
        "headerName": "Association Id"
      },
      {
        "type": "string",
        "field": "InterfaceType",
        "headerName": "Interface Type"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "MacAddress",
        "headerName": "Mac Address"
      },
      {
        "type": "string",
        "field": "PrivateIpAddress",
        "headerName": "Private Ip Address"
      }
    ],
    "id": "NetworkInterfaceId"
  },
  "aws.event-api-destination": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.event-bus": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.event-rule": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "EventPattern",
        "headerName": "Event Pattern"
      },
      {
        "type": "string",
        "field": "ScheduleExpression",
        "headerName": "Schedule Expression"
      },
      {
        "type": "string",
        "field": "ManagedBy",
        "headerName": "Managed By"
      },
      {
        "type": "string",
        "field": "EventBusName",
        "headerName": "Event Bus Name"
      }
    ],
    "id": "Name"
  },
  "aws.event-rule-target": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      },
      {
        "type": "number",
        "field": "RetryPolicy.MaximumRetryAttempts",
        "headerName": "Maximum Retry Attempts"
      },
      {
        "type": "number",
        "field": "RetryPolicy.MaximumEventAgeInSeconds",
        "headerName": "Maximum Event Age In Seconds"
      }
    ],
    "id": "Id"
  },
  "aws.eventbridge-pipes": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.firehose": {
    "columns": [
      {
        "type": "string",
        "field": "DeliveryStreamName",
        "headerName": "Delivery Stream Name"
      },
      {
        "type": "string",
        "field": "DeliveryStreamStatus",
        "headerName": "Delivery Stream Status"
      },
      {
        "type": "string",
        "field": "FailureDescription.Type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "DeliveryStreamEncryptionConfiguration.KeyARN",
        "headerName": "Key ARN"
      },
      {
        "type": "string",
        "field": "DeliveryStreamEncryptionConfiguration.KeyType",
        "headerName": "Key Type"
      },
      {
        "type": "string",
        "field": "DeliveryStreamType",
        "headerName": "Delivery Stream Type"
      },
      {
        "type": "time",
        "field": "CreateTimestamp",
        "headerName": "Create Timestamp"
      }
    ],
    "id": "DeliveryStreamName"
  },
  "aws.firewall": {
    "columns": [
      {
        "type": "string",
        "field": "FirewallName",
        "headerName": "Id"
      }
    ],
    "id": "FirewallName"
  },
  "aws.fis-experiment": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.fis-template": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.flow-log": {
    "columns": [
      {
        "type": "string",
        "field": "FlowLogId",
        "headerName": "Id"
      }
    ],
    "id": "FlowLogId"
  },
  "aws.fsx": {
    "columns": [
      {
        "type": "string",
        "field": "FileSystemId",
        "headerName": "Id"
      }
    ],
    "id": "FileSystemId"
  },
  "aws.fsx-backup": {
    "columns": [
      {
        "type": "string",
        "field": "BackupId",
        "headerName": "Id"
      }
    ],
    "id": "BackupId"
  },
  "aws.fsx-volume": {
    "columns": [
      {
        "type": "string",
        "field": "VolumeId",
        "headerName": "Id"
      }
    ],
    "id": "VolumeId"
  },
  "aws.gamelift-build": {
    "columns": [
      {
        "type": "string",
        "field": "BuildId",
        "headerName": "Build Id"
      },
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      }
    ],
    "id": "BuildId"
  },
  "aws.gamelift-fleet": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "FleetId",
        "headerName": "Fleet Id"
      },
      {
        "type": "string",
        "field": "FleetType",
        "headerName": "Fleet Type"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      }
    ],
    "id": "FleetId"
  },
  "aws.glacier": {
    "columns": [
      {
        "type": "string",
        "field": "VaultName",
        "headerName": "Vault Name"
      },
      {
        "type": "string",
        "field": "CreationDate",
        "headerName": "Creation Date"
      },
      {
        "type": "string",
        "field": "LastInventoryDate",
        "headerName": "Last Inventory Date"
      },
      {
        "type": "number",
        "field": "NumberOfArchives",
        "headerName": "Number Of Archives"
      },
      {
        "type": "number",
        "field": "SizeInBytes",
        "headerName": "Size In Bytes"
      }
    ],
    "id": "VaultName"
  },
  "aws.globalaccelerator": {
    "columns": [
      {
        "type": "string",
        "field": "AcceleratorArn",
        "headerName": "Id"
      }
    ],
    "id": "AcceleratorArn"
  },
  "aws.glue-classifier": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.glue-connection": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "ConnectionType",
        "headerName": "Connection Type"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "time",
        "field": "LastUpdatedTime",
        "headerName": "Last Updated Time"
      },
      {
        "type": "string",
        "field": "LastUpdatedBy",
        "headerName": "Last Updated By"
      }
    ],
    "id": "Name"
  },
  "aws.glue-crawler": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "LastCrawl.Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "DatabaseName",
        "headerName": "Database Name"
      }
    ],
    "id": "Name"
  },
  "aws.glue-database": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "CatalogId",
        "headerName": "Catalog Id"
      }
    ],
    "id": "Name"
  },
  "aws.glue-dev-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "EndpointName",
        "headerName": "Endpoint Name"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "CreatedTimestamp",
        "headerName": "Created Timestamp"
      },
      {
        "type": "string",
        "field": "WorkerType",
        "headerName": "Worker Type"
      },
      {
        "type": "number",
        "field": "NumberOfWorkers",
        "headerName": "Number Of Workers"
      },
      {
        "type": "number",
        "field": "NumberOfNodes",
        "headerName": "Number Of Nodes"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "PublicAddress",
        "headerName": "Public Address"
      },
      {
        "type": "string",
        "field": "PublicKey",
        "headerName": "Public Key"
      }
    ],
    "id": "EndpointName"
  },
  "aws.glue-job": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreatedOn",
        "headerName": "Created On"
      },
      {
        "type": "string",
        "field": "Command.Name",
        "headerName": "Command"
      },
      {
        "type": "number",
        "field": "Timeout",
        "headerName": "Timeout"
      },
      {
        "type": "number",
        "field": "AllocatedCapacity",
        "headerName": "Allocated Capacity"
      },
      {
        "type": "number",
        "field": "MaxCapacity",
        "headerName": "Max Capacity"
      },
      {
        "type": "number",
        "field": "NumberOfWorkers",
        "headerName": "Number Of Workers"
      },
      {
        "type": "string",
        "field": "GlueVersion",
        "headerName": "Glue Version"
      }
    ],
    "id": "Name"
  },
  "aws.glue-ml-transform": {
    "columns": [
      {
        "type": "string",
        "field": "TransformId",
        "headerName": "Id"
      }
    ],
    "id": "TransformId"
  },
  "aws.glue-security-configuration": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreatedTimeStamp",
        "headerName": "Created Time Stamp"
      }
    ],
    "id": "Name"
  },
  "aws.glue-table": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "DatabaseName",
        "headerName": "Database Name"
      },
      {
        "type": "string",
        "field": "Owner",
        "headerName": "Owner"
      },
      {
        "type": "time",
        "field": "LastAccessTime",
        "headerName": "Last Access Time"
      },
      {
        "type": "number",
        "field": "Retention",
        "headerName": "Retention"
      },
      {
        "type": "string",
        "field": "CatalogId",
        "headerName": "Catalog Id"
      }
    ],
    "id": "Name"
  },
  "aws.glue-trigger": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "WorkflowName",
        "headerName": "Workflow Name"
      },
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "Schedule",
        "headerName": "Schedule"
      }
    ],
    "id": "Name"
  },
  "aws.glue-workflow": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreatedOn",
        "headerName": "Created On"
      },
      {
        "type": "number",
        "field": "MaxConcurrentRuns",
        "headerName": "Max Concurrent Runs"
      }
    ],
    "id": "Name"
  },
  "aws.graphql-api": {
    "columns": [
      {
        "type": "string",
        "field": "apiId",
        "headerName": "Id"
      }
    ],
    "id": "apiId"
  },
  "aws.guardduty-finding": {
    "columns": [
      {
        "type": "string",
        "field": "AccountId",
        "headerName": "Id"
      }
    ],
    "id": "AccountId"
  },
  "aws.health-event": {
    "columns": [
      {
        "type": "string",
        "field": "arn",
        "headerName": "Arn"
      },
      {
        "type": "string",
        "field": "service",
        "headerName": "Service"
      },
      {
        "type": "string",
        "field": "eventTypeCode",
        "headerName": "Event Type Code"
      },
      {
        "type": "string",
        "field": "eventTypeCategory",
        "headerName": "Event Type Category"
      },
      {
        "type": "string",
        "field": "statusCode",
        "headerName": "Status Code"
      },
      {
        "type": "string",
        "field": "eventScopeCode",
        "headerName": "Event Scope Code"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      }
    ],
    "id": "arn"
  },
  "aws.healthcheck": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "LinkedService.ServicePrincipal",
        "headerName": "Service Principal"
      },
      {
        "type": "string",
        "field": "HealthCheckConfig.Type",
        "headerName": "Type"
      }
    ],
    "id": "Id"
  },
  "aws.hostedzone": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "boolean",
        "field": "Config.PrivateZone",
        "headerName": "Private Zone"
      },
      {
        "type": "number",
        "field": "ResourceRecordSetCount",
        "headerName": "Resource Record Set Count"
      }
    ],
    "id": "Id"
  },
  "aws.hsm": {
    "columns": [
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "HsmArn",
        "headerName": "Hsm Arn"
      },
      {
        "type": "string",
        "field": "SubscriptionStartDate",
        "headerName": "Subscription Start Date"
      },
      {
        "type": "string",
        "field": "SubscriptionEndDate",
        "headerName": "Subscription End Date"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "SerialNumber",
        "headerName": "Serial Number"
      },
      {
        "type": "string",
        "field": "VendorName",
        "headerName": "Vendor Name"
      },
      {
        "type": "string",
        "field": "HsmType",
        "headerName": "Hsm Type"
      },
      {
        "type": "string",
        "field": "ServerCertLastUpdated",
        "headerName": "Server Cert Last Updated"
      },
      {
        "type": "string",
        "field": "SshPublicKey",
        "headerName": "Ssh Public Key"
      }
    ],
    "id": "HsmArn"
  },
  "aws.hsm-client": {
    "columns": [
      {
        "type": "string",
        "field": "ClientArn",
        "headerName": "Client Arn"
      },
      {
        "type": "string",
        "field": "Certificate",
        "headerName": "Certificate"
      },
      {
        "type": "string",
        "field": "LastModifiedTimestamp",
        "headerName": "Last Modified Timestamp"
      },
      {
        "type": "string",
        "field": "Label",
        "headerName": "Label"
      }
    ],
    "id": "ClientArn"
  },
  "aws.hsm-hapg": {
    "columns": [
      {
        "type": "string",
        "field": "HapgArn",
        "headerName": "Hapg Arn"
      },
      {
        "type": "string",
        "field": "HapgSerial",
        "headerName": "Hapg Serial"
      },
      {
        "type": "string",
        "field": "Label",
        "headerName": "Label"
      },
      {
        "type": "string",
        "field": "LastModifiedTimestamp",
        "headerName": "Last Modified Timestamp"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      }
    ],
    "id": "HapgArn"
  },
  "aws.iam-access-key": {
    "columns": [
      {
        "type": "string",
        "field": "AccessKeyId",
        "headerName": "Id"
      }
    ],
    "id": "AccessKeyId"
  },
  "aws.iam-certificate": {
    "columns": [
      {
        "type": "string",
        "field": "ServerCertificateName",
        "headerName": "Server Certificate Name"
      },
      {
        "type": "string",
        "field": "ServerCertificateId",
        "headerName": "Server Certificate Id"
      },
      {
        "type": "time",
        "field": "UploadDate",
        "headerName": "Upload Date"
      },
      {
        "type": "time",
        "field": "Expiration",
        "headerName": "Expiration"
      }
    ],
    "id": "ServerCertificateName"
  },
  "aws.iam-group": {
    "columns": [
      {
        "type": "string",
        "field": "GroupName",
        "headerName": "Group Name"
      },
      {
        "type": "string",
        "field": "GroupId",
        "headerName": "Group Id"
      },
      {
        "type": "time",
        "field": "CreateDate",
        "headerName": "Create Date"
      }
    ],
    "id": "GroupName"
  },
  "aws.iam-oidc-provider": {
    "columns": [
      {
        "type": "string",
        "field": "Url",
        "headerName": "Url"
      },
      {
        "type": "time",
        "field": "CreateDate",
        "headerName": "Create Date"
      }
    ],
    "id": "Arn"
  },
  "aws.iam-policy": {
    "columns": [
      {
        "type": "string",
        "field": "PolicyName",
        "headerName": "Policy Name"
      },
      {
        "type": "string",
        "field": "PolicyId",
        "headerName": "Policy Id"
      },
      {
        "type": "number",
        "field": "PermissionsBoundaryUsageCount",
        "headerName": "Permissions Boundary Usage Count"
      },
      {
        "type": "boolean",
        "field": "IsAttachable",
        "headerName": "Is Attachable"
      },
      {
        "type": "time",
        "field": "CreateDate",
        "headerName": "Create Date"
      },
      {
        "type": "time",
        "field": "UpdateDate",
        "headerName": "Update Date"
      }
    ],
    "id": "PolicyId"
  },
  "aws.iam-profile": {
    "columns": [
      {
        "type": "string",
        "field": "InstanceProfileName",
        "headerName": "Instance Profile Name"
      },
      {
        "type": "string",
        "field": "InstanceProfileId",
        "headerName": "Instance Profile Id"
      },
      {
        "type": "string",
        "field": "Path",
        "headerName": "Path"
      },
      {
        "type": "time",
        "field": "CreateDate",
        "headerName": "Create Date"
      }
    ],
    "id": "InstanceProfileName"
  },
  "aws.iam-role": {
    "columns": [
      {
        "type": "string",
        "field": "RoleName",
        "headerName": "Role Name"
      },
      {
        "type": "string",
        "field": "RoleId",
        "headerName": "Role Id"
      },
      {
        "type": "time",
        "field": "CreateDate",
        "headerName": "Create Date"
      },
      {
        "type": "string",
        "field": "Arn",
        "headerName": "Arn"
      },
      {
        "type": "time",
        "field": "RoleLastUsed.LastUsedDate",
        "headerName": "Last Used Date"
      }
    ],
    "id": "RoleName"
  },
  "aws.iam-saml-provider": {
    "columns": [
      {
        "type": "string",
        "field": "SAMLMetadataDocument",
        "headerName": "SAML Metadata Document"
      },
      {
        "type": "time",
        "field": "CreateDate",
        "headerName": "Create Date"
      },
      {
        "type": "time",
        "field": "ValidUntil",
        "headerName": "Valid Until"
      }
    ],
    "id": "Arn"
  },
  "aws.iam-user": {
    "columns": [
      {
        "type": "string",
        "field": "UserName",
        "headerName": "User Name"
      },
      {
        "type": "string",
        "field": "UserId",
        "headerName": "User Id"
      },
      {
        "type": "time",
        "field": "CreateDate",
        "headerName": "Create Date"
      },
      {
        "type": "time",
        "field": "PasswordLastUsed",
        "headerName": "Password Last Used"
      },
      {
        "type": "string",
        "field": "PermissionsBoundary.PermissionsBoundaryType",
        "headerName": "Permissions Boundary Type"
      }
    ],
    "id": "UserName"
  },
  "aws.identity-pool": {
    "columns": [
      {
        "type": "string",
        "field": "IdentityPoolName",
        "headerName": "Identity Pool Name"
      },
      {
        "type": "string",
        "field": "IdentityPoolId",
        "headerName": "Identity Pool Id"
      },
      {
        "type": "boolean",
        "field": "AllowUnauthenticatedIdentities",
        "headerName": "Allow Unauthenticated Identities"
      },
      {
        "type": "boolean",
        "field": "AllowClassicFlow",
        "headerName": "Allow Classic Flow"
      }
    ],
    "id": "IdentityPoolId"
  },
  "aws.insight-rule": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "Schema",
        "headerName": "Schema"
      }
    ],
    "id": "Name"
  },
  "aws.inspector2-finding": {
    "columns": [
      {
        "type": "string",
        "field": "findingArn",
        "headerName": "Id"
      }
    ],
    "id": "findingArn"
  },
  "aws.internet-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "InternetGatewayId",
        "headerName": "Internet Gateway Id"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      },
      {
        "type": "string",
        "field": "Attachments[0].State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "Attachments[0].VpcId",
        "headerName": "Vpc Id"
      }
    ],
    "id": "InternetGatewayId"
  },
  "aws.iot": {
    "columns": [
      {
        "type": "string",
        "field": "thingName",
        "headerName": "Thing Name"
      },
      {
        "type": "string",
        "field": "thingTypeName",
        "headerName": "Thing Type Name"
      },
      {
        "type": "number",
        "field": "version",
        "headerName": "Version"
      }
    ],
    "id": "thingName"
  },
  "aws.kafka": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterName",
        "headerName": "Cluster Name"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      }
    ],
    "id": "ClusterArn"
  },
  "aws.kafka-config": {
    "columns": [
      {
        "type": "string",
        "field": "Arn",
        "headerName": "Id"
      }
    ],
    "id": "Arn"
  },
  "aws.kendra": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.key-pair": {
    "columns": [
      {
        "type": "string",
        "field": "KeyName",
        "headerName": "Key Name"
      },
      {
        "type": "string",
        "field": "KeyPairId",
        "headerName": "Key Pair Id"
      }
    ],
    "id": "KeyPairId"
  },
  "aws.keyspace": {
    "columns": [
      {
        "type": "string",
        "field": "keyspaceName",
        "headerName": "Id"
      }
    ],
    "id": "keyspaceName"
  },
  "aws.keyspace-table": {
    "columns": [
      {
        "type": "string",
        "field": "tableName",
        "headerName": "Id"
      }
    ],
    "id": "tableName"
  },
  "aws.kinesis": {
    "columns": [
      {
        "type": "string",
        "field": "StreamName",
        "headerName": "Stream Name"
      },
      {
        "type": "string",
        "field": "StreamARN",
        "headerName": "Stream ARN"
      },
      {
        "type": "string",
        "field": "StreamStatus",
        "headerName": "Stream Status"
      },
      {
        "type": "time",
        "field": "StreamCreationTimestamp",
        "headerName": "Stream Creation Timestamp"
      },
      {
        "type": "string",
        "field": "EncryptionType",
        "headerName": "Encryption Type"
      },
      {
        "type": "string",
        "field": "KeyId",
        "headerName": "Key Id"
      }
    ],
    "id": "StreamName"
  },
  "aws.kinesis-analytics": {
    "columns": [
      {
        "type": "string",
        "field": "ApplicationName",
        "headerName": "Application Name"
      },
      {
        "type": "string",
        "field": "ApplicationStatus",
        "headerName": "Application Status"
      },
      {
        "type": "time",
        "field": "CreateTimestamp",
        "headerName": "Create Timestamp"
      }
    ],
    "id": "ApplicationARN"
  },
  "aws.kinesis-analyticsv2": {
    "columns": [
      {
        "type": "string",
        "field": "ApplicationARN",
        "headerName": "Id"
      }
    ],
    "id": "ApplicationARN"
  },
  "aws.kinesis-video": {
    "columns": [
      {
        "type": "string",
        "field": "StreamName",
        "headerName": "Id"
      }
    ],
    "id": "StreamName"
  },
  "aws.kms": {
    "columns": [
      {
        "type": "string",
        "field": "AliasName",
        "headerName": "Alias Name"
      },
      {
        "type": "string",
        "field": "TargetKeyId",
        "headerName": "Target Key Id"
      },
      {
        "type": "time",
        "field": "CreationDate",
        "headerName": "Creation Date"
      }
    ],
    "id": "AliasArn"
  },
  "aws.kms-key": {
    "columns": [
      {
        "type": "string",
        "field": "KeyId",
        "headerName": "Key Id"
      },
      {
        "type": "time",
        "field": "CreationDate",
        "headerName": "Creation Date"
      },
      {
        "type": "string",
        "field": "KeyUsage",
        "headerName": "Key Usage"
      },
      {
        "type": "string",
        "field": "KeyState",
        "headerName": "Key State"
      },
      {
        "type": "string",
        "field": "KeyManager",
        "headerName": "Key Manager"
      },
      {
        "type": "time",
        "field": "ValidTo",
        "headerName": "Valid To"
      },
      {
        "type": "string",
        "field": "Origin",
        "headerName": "Origin"
      }
    ],
    "id": "KeyId"
  },
  "aws.lambda": {
    "columns": [
      {
        "type": "string",
        "field": "FunctionName",
        "headerName": "Function Name"
      },
      {
        "type": "string",
        "field": "Runtime",
        "headerName": "Runtime"
      },
      {
        "type": "string",
        "field": "Version",
        "headerName": "Version"
      },
      {
        "type": "string",
        "field": "LastModified",
        "headerName": "Last Modified"
      },
      {
        "type": "string",
        "field": "VpcConfig.VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "array",
        "field": "VpcConfig.SubnetIds",
        "headerName": "Subnet Ids"
      },
      {
        "type": "string",
        "field": "KMSKeyArn",
        "headerName": "KMS Key Arn"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "StateReasonCode",
        "headerName": "State Reason Code"
      },
      {
        "type": "string",
        "field": "TracingConfig.Mode",
        "headerName": "Mode"
      }
    ],
    "id": "FunctionName"
  },
  "aws.lambda-event-source-mapping": {
    "columns": [
      {
        "type": "string",
        "field": "UUID",
        "headerName": "Id"
      }
    ],
    "id": "UUID"
  },
  "aws.lambda-layer": {
    "columns": [
      {
        "type": "string",
        "field": "LayerName",
        "headerName": "Layer Name"
      },
      {
        "type": "number",
        "field": "LatestMatchingVersion.Version",
        "headerName": "Version"
      },
      {
        "type": "string",
        "field": "LatestMatchingVersion.CreatedDate",
        "headerName": "Created Date"
      }
    ],
    "id": "LayerName"
  },
  "aws.launch-config": {
    "columns": [
      {
        "type": "string",
        "field": "LaunchConfigurationName",
        "headerName": "Launch Configuration Name"
      },
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Image Id"
      },
      {
        "type": "string",
        "field": "KeyName",
        "headerName": "Key Name"
      },
      {
        "type": "string",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "boolean",
        "field": "AssociatePublicIpAddress",
        "headerName": "Associate Public Ip Address"
      }
    ],
    "id": "LaunchConfigurationName"
  },
  "aws.launch-template-version": {
    "columns": [
      {
        "type": "string",
        "field": "LaunchTemplateName",
        "headerName": "Launch Template Name"
      },
      {
        "type": "string",
        "field": "LaunchTemplateId",
        "headerName": "Launch Template Id"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "CreatedBy",
        "headerName": "Created By"
      }
    ],
    "id": "LaunchTemplateId"
  },
  "aws.lex-bot": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Id"
      }
    ],
    "id": "name"
  },
  "aws.lexv2-bot": {
    "columns": [
      {
        "type": "string",
        "field": "botId",
        "headerName": "Id"
      }
    ],
    "id": "botId"
  },
  "aws.lexv2-bot-alias": {
    "columns": [
      {
        "type": "string",
        "field": "botAliasId",
        "headerName": "Id"
      }
    ],
    "id": "botAliasId"
  },
  "aws.lightsail-db": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "supportCode",
        "headerName": "Support Code"
      },
      {
        "type": "time",
        "field": "createdAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "location.regionName",
        "headerName": "Region Name"
      },
      {
        "type": "string",
        "field": "resourceType",
        "headerName": "Resource Type"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "engine",
        "headerName": "Engine"
      },
      {
        "type": "string",
        "field": "engineVersion",
        "headerName": "Engine Version"
      },
      {
        "type": "boolean",
        "field": "publiclyAccessible",
        "headerName": "Publicly Accessible"
      }
    ],
    "id": "arn"
  },
  "aws.lightsail-elb": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "supportCode",
        "headerName": "Support Code"
      },
      {
        "type": "time",
        "field": "createdAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "location.regionName",
        "headerName": "Region Name"
      },
      {
        "type": "string",
        "field": "resourceType",
        "headerName": "Resource Type"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "protocol",
        "headerName": "Protocol"
      }
    ],
    "id": "arn"
  },
  "aws.lightsail-instance": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "supportCode",
        "headerName": "Support Code"
      },
      {
        "type": "time",
        "field": "createdAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "location.regionName",
        "headerName": "Region Name"
      },
      {
        "type": "string",
        "field": "resourceType",
        "headerName": "Resource Type"
      },
      {
        "type": "string",
        "field": "state.name",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "publicIpAddress",
        "headerName": "Public Ip Address"
      }
    ],
    "id": "arn"
  },
  "aws.log-group": {
    "columns": [
      {
        "type": "string",
        "field": "logGroupName",
        "headerName": "Log Group Name"
      },
      {
        "type": "number",
        "field": "creationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "number",
        "field": "retentionInDays",
        "headerName": "Retention In Days"
      },
      {
        "type": "number",
        "field": "storedBytes",
        "headerName": "Stored Bytes"
      },
      {
        "type": "number",
        "field": "metricFilterCount",
        "headerName": "Metric Filter Count"
      },
      {
        "type": "string",
        "field": "kmsKeyId",
        "headerName": "Kms Key Id"
      }
    ],
    "id": "logGroupName"
  },
  "aws.log-metric": {
    "columns": [
      {
        "type": "string",
        "field": "filterName",
        "headerName": "Id"
      }
    ],
    "id": "filterName"
  },
  "aws.memorydb": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.memorydb-acl": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.memorydb-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.memorydb-subnet-group": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.memorydb-user": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.message-broker": {
    "columns": [
      {
        "type": "string",
        "field": "BrokerId",
        "headerName": "Broker Id"
      },
      {
        "type": "string",
        "field": "BrokerName",
        "headerName": "Broker Name"
      },
      {
        "type": "string",
        "field": "BrokerState",
        "headerName": "Broker State"
      },
      {
        "type": "time",
        "field": "Created",
        "headerName": "Created"
      },
      {
        "type": "boolean",
        "field": "PubliclyAccessible",
        "headerName": "Publicly Accessible"
      },
      {
        "type": "string",
        "field": "DeploymentMode",
        "headerName": "Deployment Mode"
      },
      {
        "type": "string",
        "field": "EngineType",
        "headerName": "Engine Type"
      }
    ],
    "id": "BrokerId"
  },
  "aws.message-config": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      },
      {
        "type": "time",
        "field": "Created",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "EngineType",
        "headerName": "Engine Type"
      },
      {
        "type": "string",
        "field": "EngineVersion",
        "headerName": "Engine Version"
      },
      {
        "type": "string",
        "field": "AuthenticationStrategy",
        "headerName": "Authentication Strategy"
      }
    ],
    "id": "Id"
  },
  "aws.mirror-session": {
    "columns": [
      {
        "type": "string",
        "field": "TrafficMirrorSessionId",
        "headerName": "Id"
      }
    ],
    "id": "TrafficMirrorSessionId"
  },
  "aws.mirror-target": {
    "columns": [
      {
        "type": "string",
        "field": "TrafficMirrorTargetId",
        "headerName": "Id"
      }
    ],
    "id": "TrafficMirrorTargetId"
  },
  "aws.ml-model": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "MLModelId",
        "headerName": "ML Model Id"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "CreatedAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "CreatedByIamUser",
        "headerName": "Created By Iam User"
      },
      {
        "type": "number",
        "field": "SizeInBytes",
        "headerName": "Size In Bytes"
      }
    ],
    "id": "MLModelId"
  },
  "aws.nat-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "NatGatewayId",
        "headerName": "Nat Gateway Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      }
    ],
    "id": "NatGatewayId"
  },
  "aws.network-acl": {
    "columns": [
      {
        "type": "string",
        "field": "NetworkAclId",
        "headerName": "Network Acl Id"
      },
      {
        "type": "boolean",
        "field": "IsDefault",
        "headerName": "Is Default"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      }
    ],
    "id": "NetworkAclId"
  },
  "aws.network-addr": {
    "c7n-alias-for": "aws.elastic-ip"
  },
  "aws.networkmanager-core": {
    "columns": [
      {
        "type": "string",
        "field": "CoreNetworkId",
        "headerName": "Id"
      }
    ],
    "id": "CoreNetworkId"
  },
  "aws.networkmanager-device": {
    "columns": [
      {
        "type": "string",
        "field": "DeviceId",
        "headerName": "Id"
      }
    ],
    "id": "DeviceId"
  },
  "aws.networkmanager-global": {
    "columns": [
      {
        "type": "string",
        "field": "GlobalNetworkId",
        "headerName": "Id"
      }
    ],
    "id": "GlobalNetworkId"
  },
  "aws.networkmanager-link": {
    "columns": [
      {
        "type": "string",
        "field": "LinkId",
        "headerName": "Id"
      }
    ],
    "id": "LinkId"
  },
  "aws.networkmanager-site": {
    "columns": [
      {
        "type": "string",
        "field": "SiteId",
        "headerName": "Id"
      }
    ],
    "id": "SiteId"
  },
  "aws.opensearch-ingestion": {
    "columns": [
      {
        "type": "string",
        "field": "PipelineName",
        "headerName": "Id"
      }
    ],
    "id": "PipelineName"
  },
  "aws.opensearch-reserved": {
    "columns": [
      {
        "type": "string",
        "field": "ReservedInstanceId",
        "headerName": "Id"
      }
    ],
    "id": "ReservedInstanceId"
  },
  "aws.opensearch-serverless": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.ops-item": {
    "columns": [
      {
        "type": "string",
        "field": "OpsItemId",
        "headerName": "Id"
      }
    ],
    "id": "OpsItemId"
  },
  "aws.org-account": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.org-policy": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.org-unit": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.origin-access-control": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.payment-cryptography-key": {
    "columns": [
      {
        "type": "string",
        "field": "KeyArn",
        "headerName": "Id"
      }
    ],
    "id": "KeyArn"
  },
  "aws.peering-connection": {
    "columns": [
      {
        "type": "string",
        "field": "VpcPeeringConnectionId",
        "headerName": "Vpc Peering Connection Id"
      },
      {
        "type": "string",
        "field": "Status.Code",
        "headerName": "Code"
      },
      {
        "type": "string",
        "field": "AccepterVpcInfo.VpcId",
        "headerName": "Accepter Vpc Id"
      },
      {
        "type": "string",
        "field": "AccepterVpcInfo.Region",
        "headerName": "Accepter Vpc Region"
      },
      {
        "type": "string",
        "field": "AccepterVpcInfo.CidrBlock",
        "headerName": "Accepter Vpc Cidr"
      },
      {
        "type": "string",
        "field": "RequesterVpcInfo.VpcId",
        "headerName": "Requester Vpc Id"
      },
      {
        "type": "string",
        "field": "RequesterVpcInfo.Region",
        "headerName": "Requester Vpc Region"
      },
      {
        "type": "string",
        "field": "RequesterVpcInfo.CidrBlock",
        "headerName": "Requester Vpc Cidr"
      }
    ],
    "id": "VpcPeeringConnectionId"
  },
  "aws.pinpoint-app": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.prefix-list": {
    "columns": [
      {
        "type": "string",
        "field": "PrefixListId",
        "headerName": "Id"
      }
    ],
    "id": "PrefixListId"
  },
  "aws.quicksight-dashboard": {
    "columns": [
      {
        "type": "string",
        "field": "DashboardId",
        "headerName": "Id"
      }
    ],
    "id": "DashboardId"
  },
  "aws.quicksight-datasource": {
    "columns": [
      {
        "type": "string",
        "field": "DataSourceId",
        "headerName": "Id"
      }
    ],
    "id": "DataSourceId"
  },
  "aws.quicksight-group": {
    "columns": [
      {
        "type": "string",
        "field": "GroupName",
        "headerName": "Id"
      }
    ],
    "id": "GroupName"
  },
  "aws.quicksight-user": {
    "columns": [
      {
        "type": "string",
        "field": "UserName",
        "headerName": "Id"
      }
    ],
    "id": "UserName"
  },
  "aws.r53domain": {
    "columns": [
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "boolean",
        "field": "AutoRenew",
        "headerName": "Auto Renew"
      },
      {
        "type": "time",
        "field": "ExpirationDate",
        "headerName": "Expiration Date"
      }
    ],
    "id": "DomainName"
  },
  "aws.rds": {
    "columns": [
      {
        "type": "string",
        "field": "DBName",
        "headerName": "DB Name"
      },
      {
        "type": "string",
        "field": "DBInstanceIdentifier",
        "headerName": "DB Instance Identifier"
      },
      {
        "type": "boolean",
        "field": "PubliclyAccessible",
        "headerName": "Publicly Accessible"
      },
      {
        "type": "string",
        "field": "DBInstanceStatus",
        "headerName": "DB Instance Status"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "string",
        "field": "Engine",
        "headerName": "Engine"
      },
      {
        "type": "time",
        "field": "InstanceCreateTime",
        "headerName": "Instance Create Time"
      },
      {
        "type": "number",
        "field": "BackupRetentionPeriod",
        "headerName": "Backup Retention Period"
      },
      {
        "type": "boolean",
        "field": "MultiAZ",
        "headerName": "Multi AZ"
      },
      {
        "type": "string",
        "field": "DBSubnetGroup.VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "boolean",
        "field": "DeletionProtection",
        "headerName": "Deletion Protection"
      }
    ],
    "id": "DBInstanceIdentifier"
  },
  "aws.rds-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "DatabaseName",
        "headerName": "Database Name"
      },
      {
        "type": "string",
        "field": "DBClusterIdentifier",
        "headerName": "DB Cluster Identifier"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "ClusterCreateTime",
        "headerName": "Cluster Create Time"
      },
      {
        "type": "number",
        "field": "AllocatedStorage",
        "headerName": "Allocated Storage"
      },
      {
        "type": "number",
        "field": "BackupRetentionPeriod",
        "headerName": "Backup Retention Period"
      },
      {
        "type": "boolean",
        "field": "MultiAZ",
        "headerName": "Multi AZ"
      },
      {
        "type": "string",
        "field": "Engine",
        "headerName": "Engine"
      },
      {
        "type": "string",
        "field": "EngineVersion",
        "headerName": "Engine Version"
      },
      {
        "type": "boolean",
        "field": "StorageEncrypted",
        "headerName": "Storage Encrypted"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "boolean",
        "field": "DeletionProtection",
        "headerName": "Deletion Protection"
      },
      {
        "type": "array",
        "field": "EnabledCloudwatchLogsExports",
        "headerName": "Enabled Cloudwatch Logs Exports"
      }
    ],
    "id": "DBClusterIdentifier"
  },
  "aws.rds-cluster-param-group": {
    "columns": [
      {
        "type": "string",
        "field": "DBClusterParameterGroupName",
        "headerName": "Id"
      }
    ],
    "id": "DBClusterParameterGroupName"
  },
  "aws.rds-cluster-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "DBClusterSnapshotIdentifier",
        "headerName": "Id"
      }
    ],
    "id": "DBClusterSnapshotIdentifier"
  },
  "aws.rds-db-shard-group": {
    "columns": [
      {
        "type": "string",
        "field": "DBShardGroupResourceId",
        "headerName": "Id"
      }
    ],
    "id": "DBShardGroupResourceId"
  },
  "aws.rds-param-group": {
    "columns": [
      {
        "type": "string",
        "field": "DBParameterGroupName",
        "headerName": "Id"
      }
    ],
    "id": "DBParameterGroupName"
  },
  "aws.rds-proxy": {
    "columns": [
      {
        "type": "string",
        "field": "DBProxyName",
        "headerName": "Id"
      }
    ],
    "id": "DBProxyName"
  },
  "aws.rds-reserved": {
    "columns": [
      {
        "type": "string",
        "field": "ReservedDBInstanceId",
        "headerName": "Id"
      }
    ],
    "id": "ReservedDBInstanceId"
  },
  "aws.rds-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "DBSnapshotIdentifier",
        "headerName": "DB Snapshot Identifier"
      },
      {
        "type": "time",
        "field": "SnapshotCreateTime",
        "headerName": "Snapshot Create Time"
      },
      {
        "type": "string",
        "field": "DBInstanceIdentifier",
        "headerName": "DB Instance Identifier"
      },
      {
        "type": "string",
        "field": "SnapshotType",
        "headerName": "Snapshot Type"
      }
    ],
    "id": "DBSnapshotIdentifier"
  },
  "aws.rds-subnet-group": {
    "columns": [
      {
        "type": "string",
        "field": "DBSubnetGroupName",
        "headerName": "Id"
      }
    ],
    "id": "DBSubnetGroupName"
  },
  "aws.rds-subscription": {
    "columns": [
      {
        "type": "string",
        "field": "CustSubscriptionId",
        "headerName": "Id"
      }
    ],
    "id": "CustSubscriptionId"
  },
  "aws.readiness-check": {
    "columns": [
      {
        "type": "string",
        "field": "ReadinessCheckName",
        "headerName": "Id"
      }
    ],
    "id": "ReadinessCheckName"
  },
  "aws.recovery-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterArn",
        "headerName": "Id"
      }
    ],
    "id": "ClusterArn"
  },
  "aws.recovery-control-panel": {
    "columns": [
      {
        "type": "string",
        "field": "ControlPanelArn",
        "headerName": "Id"
      }
    ],
    "id": "ControlPanelArn"
  },
  "aws.redshift": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterIdentifier",
        "headerName": "Cluster Identifier"
      },
      {
        "type": "time",
        "field": "ClusterCreateTime",
        "headerName": "Cluster Create Time"
      },
      {
        "type": "string",
        "field": "NodeType",
        "headerName": "Node Type"
      },
      {
        "type": "string",
        "field": "ClusterStatus",
        "headerName": "Cluster Status"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "number",
        "field": "NumberOfNodes",
        "headerName": "Number Of Nodes"
      },
      {
        "type": "string",
        "field": "DBName",
        "headerName": "DB Name"
      },
      {
        "type": "boolean",
        "field": "PubliclyAccessible",
        "headerName": "Publicly Accessible"
      },
      {
        "type": "boolean",
        "field": "Encrypted",
        "headerName": "Encrypted"
      }
    ],
    "id": "ClusterIdentifier"
  },
  "aws.redshift-reserved": {
    "columns": [
      {
        "type": "string",
        "field": "ReservedNodeId",
        "headerName": "Id"
      }
    ],
    "id": "ReservedNodeId"
  },
  "aws.redshift-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "SnapshotIdentifier",
        "headerName": "Snapshot Identifier"
      },
      {
        "type": "string",
        "field": "DBName",
        "headerName": "DB Name"
      }
    ],
    "id": "SnapshotIdentifier"
  },
  "aws.redshift-subnet-group": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterSubnetGroupName",
        "headerName": "Id"
      }
    ],
    "id": "ClusterSubnetGroupName"
  },
  "aws.resolver-logs": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.resolver-rule": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.resource-share-other": {
    "columns": [
      {
        "type": "string",
        "field": "resourceShareArn",
        "headerName": "Id"
      }
    ],
    "id": "resourceShareArn"
  },
  "aws.resource-share-self": {
    "columns": [
      {
        "type": "string",
        "field": "resourceShareArn",
        "headerName": "Id"
      }
    ],
    "id": "resourceShareArn"
  },
  "aws.rest-api": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "createdDate",
        "headerName": "Created Date"
      },
      {
        "type": "array",
        "field": "endpointConfiguration.types",
        "headerName": "Types"
      }
    ],
    "id": "id"
  },
  "aws.rest-client-certificate": {
    "columns": [
      {
        "type": "string",
        "field": "clientCertificateId",
        "headerName": "Id"
      }
    ],
    "id": "clientCertificateId"
  },
  "aws.rest-resource": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.rest-stage": {
    "columns": [
      {
        "type": "string",
        "field": "deploymentId",
        "headerName": "Deployment Id"
      },
      {
        "type": "string",
        "field": "stageName",
        "headerName": "Stage Name"
      },
      {
        "type": "boolean",
        "field": "cacheClusterEnabled",
        "headerName": "Cache Cluster Enabled"
      },
      {
        "type": "boolean",
        "field": "tracingEnabled",
        "headerName": "Tracing Enabled"
      },
      {
        "type": "time",
        "field": "createdDate",
        "headerName": "Created Date"
      },
      {
        "type": "time",
        "field": "lastUpdatedDate",
        "headerName": "Last Updated Date"
      },
      {
        "type": "string",
        "field": "webAclArn",
        "headerName": "Web Acl Arn"
      }
    ],
    "id": "deploymentId"
  },
  "aws.rest-vpclink": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.route-table": {
    "columns": [
      {
        "type": "string",
        "field": "RouteTableId",
        "headerName": "Route Table Id"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      }
    ],
    "id": "RouteTableId"
  },
  "aws.rrset": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.s3": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreationDate",
        "headerName": "Creation Date"
      },
      {
        "type": "string",
        "field": "Location.LocationConstraint",
        "headerName": "Location Constraint"
      },
      {
        "type": "string",
        "field": "Versioning.Status",
        "headerName": "Status"
      }
    ],
    "id": "Name"
  },
  "aws.s3-access-point": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.s3-access-point-multi": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.s3-directory": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.s3-storage-lens": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.sagemaker-auto-ml-job": {
    "columns": [
      {
        "type": "string",
        "field": "AutoMLJobArn",
        "headerName": "Id"
      }
    ],
    "id": "AutoMLJobArn"
  },
  "aws.sagemaker-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterArn",
        "headerName": "Id"
      }
    ],
    "id": "ClusterArn"
  },
  "aws.sagemaker-compilation-job": {
    "columns": [
      {
        "type": "string",
        "field": "CompilationJobArn",
        "headerName": "Id"
      }
    ],
    "id": "CompilationJobArn"
  },
  "aws.sagemaker-data-quality-job-definition": {
    "columns": [
      {
        "type": "string",
        "field": "JobDefinitionArn",
        "headerName": "Id"
      }
    ],
    "id": "JobDefinitionArn"
  },
  "aws.sagemaker-domain": {
    "columns": [
      {
        "type": "string",
        "field": "DomainId",
        "headerName": "Id"
      }
    ],
    "id": "DomainId"
  },
  "aws.sagemaker-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "EndpointArn",
        "headerName": "Id"
      }
    ],
    "id": "EndpointArn"
  },
  "aws.sagemaker-endpoint-config": {
    "columns": [
      {
        "type": "string",
        "field": "EndpointConfigArn",
        "headerName": "Id"
      }
    ],
    "id": "EndpointConfigArn"
  },
  "aws.sagemaker-hyperparameter-tuning-job": {
    "columns": [
      {
        "type": "string",
        "field": "HyperParameterTuningJobArn",
        "headerName": "Id"
      }
    ],
    "id": "HyperParameterTuningJobArn"
  },
  "aws.sagemaker-job": {
    "columns": [
      {
        "type": "string",
        "field": "TrainingJobArn",
        "headerName": "Id"
      }
    ],
    "id": "TrainingJobArn"
  },
  "aws.sagemaker-model": {
    "columns": [
      {
        "type": "string",
        "field": "ModelArn",
        "headerName": "Id"
      }
    ],
    "id": "ModelArn"
  },
  "aws.sagemaker-model-bias-job-definition": {
    "columns": [
      {
        "type": "string",
        "field": "JobDefinitionArn",
        "headerName": "Id"
      }
    ],
    "id": "JobDefinitionArn"
  },
  "aws.sagemaker-model-explainability-job-definition": {
    "columns": [
      {
        "type": "string",
        "field": "JobDefinitionArn",
        "headerName": "Id"
      }
    ],
    "id": "JobDefinitionArn"
  },
  "aws.sagemaker-model-quality-job-definition": {
    "columns": [
      {
        "type": "string",
        "field": "JobDefinitionArn",
        "headerName": "Id"
      }
    ],
    "id": "JobDefinitionArn"
  },
  "aws.sagemaker-notebook": {
    "columns": [
      {
        "type": "string",
        "field": "NotebookInstanceArn",
        "headerName": "Id"
      }
    ],
    "id": "NotebookInstanceArn"
  },
  "aws.sagemaker-processing-job": {
    "columns": [
      {
        "type": "string",
        "field": "ProcessingJobArn",
        "headerName": "Id"
      }
    ],
    "id": "ProcessingJobArn"
  },
  "aws.sagemaker-transform-job": {
    "columns": [
      {
        "type": "string",
        "field": "TransformJobArn",
        "headerName": "Id"
      }
    ],
    "id": "TransformJobArn"
  },
  "aws.savings-plan": {
    "columns": [
      {
        "type": "string",
        "field": "SavingsPlanId",
        "headerName": "Id"
      }
    ],
    "id": "SavingsPlanId"
  },
  "aws.scaling-policy": {
    "columns": [
      {
        "type": "string",
        "field": "PolicyName",
        "headerName": "Id"
      }
    ],
    "id": "PolicyName"
  },
  "aws.secrets-manager": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "time",
        "field": "CreatedDate",
        "headerName": "Created Date"
      },
      {
        "type": "string",
        "field": "KmsKeyId",
        "headerName": "Kms Key Id"
      },
      {
        "type": "boolean",
        "field": "RotationEnabled",
        "headerName": "Rotation Enabled"
      },
      {
        "type": "time",
        "field": "LastRotatedDate",
        "headerName": "Last Rotated Date"
      },
      {
        "type": "time",
        "field": "LastAccessedDate",
        "headerName": "Last Accessed Date"
      }
    ],
    "id": "Name"
  },
  "aws.security-group": {
    "columns": [
      {
        "type": "string",
        "field": "GroupName",
        "headerName": "Group Name"
      },
      {
        "type": "string",
        "field": "GroupId",
        "headerName": "Group Id"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      }
    ],
    "id": "GroupId"
  },
  "aws.security-hub": {
    "columns": [
      {
        "type": "string",
        "field": "HubArn",
        "headerName": "Id"
      }
    ],
    "id": "HubArn"
  },
  "aws.securityhub-finding": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.serverless-app": {
    "columns": [
      {
        "type": "string",
        "field": "ApplicationId",
        "headerName": "Id"
      }
    ],
    "id": "ApplicationId"
  },
  "aws.service-quota": {
    "columns": [
      {
        "type": "string",
        "field": "QuotaCode",
        "headerName": "Id"
      }
    ],
    "id": "QuotaCode"
  },
  "aws.service-quota-request": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.servicediscovery-namespace": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.ses-configuration-set": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.ses-configuration-set-v2": {
    "columns": [
      {
        "type": "string",
        "field": "ConfigurationSetName",
        "headerName": "Id"
      }
    ],
    "id": "ConfigurationSetName"
  },
  "aws.ses-dedicated-ip-pool": {
    "columns": [
      {
        "type": "string",
        "field": "PoolName",
        "headerName": "Id"
      }
    ],
    "id": "PoolName"
  },
  "aws.ses-email-identity": {
    "columns": [
      {
        "type": "string",
        "field": "IdentityName",
        "headerName": "Id"
      }
    ],
    "id": "IdentityName"
  },
  "aws.ses-ingress-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "IngressPointId",
        "headerName": "Id"
      }
    ],
    "id": "IngressPointId"
  },
  "aws.ses-receipt-rule-set": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.sfn-activity": {
    "columns": [
      {
        "type": "string",
        "field": "activityArn",
        "headerName": "Id"
      }
    ],
    "id": "activityArn"
  },
  "aws.shield-attack": {
    "columns": [
      {
        "type": "string",
        "field": "AttackId",
        "headerName": "Id"
      }
    ],
    "id": "AttackId"
  },
  "aws.shield-protection": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.simpledb": {
    "columns": [],
    "id": "DomainName"
  },
  "aws.snowball": {
    "columns": [
      {
        "type": "string",
        "field": "JobId",
        "headerName": "Id"
      }
    ],
    "id": "JobId"
  },
  "aws.snowball-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "ClusterId",
        "headerName": "Id"
      }
    ],
    "id": "ClusterId"
  },
  "aws.sns": {
    "columns": [
      {
        "type": "string",
        "field": "TopicArn",
        "headerName": "Topic Arn"
      },
      {
        "type": "string",
        "field": "DisplayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "KmsMasterKeyId",
        "headerName": "Kms Master Key Id"
      }
    ],
    "id": "TopicArn"
  },
  "aws.sns-subscription": {
    "columns": [
      {
        "type": "string",
        "field": "SubscriptionArn",
        "headerName": "Id"
      }
    ],
    "id": "SubscriptionArn"
  },
  "aws.sqs": {
    "columns": [
      {
        "type": "string",
        "field": "QueueUrl",
        "headerName": "Queue Url"
      },
      {
        "type": "time",
        "field": "CreatedTimestamp",
        "headerName": "Created Timestamp"
      },
      {
        "type": "string",
        "field": "KmsMasterKeyId",
        "headerName": "Kms Master Key Id"
      },
      {
        "type": "string",
        "field": "FifoQueue",
        "headerName": "Fifo Queue"
      }
    ],
    "id": "QueueUrl"
  },
  "aws.ssm-activation": {
    "columns": [
      {
        "type": "string",
        "field": "ActivationId",
        "headerName": "Id"
      }
    ],
    "id": "ActivationId"
  },
  "aws.ssm-data-sync": {
    "columns": [
      {
        "type": "string",
        "field": "SyncName",
        "headerName": "Id"
      }
    ],
    "id": "SyncName"
  },
  "aws.ssm-document": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.ssm-managed-instance": {
    "columns": [
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Id"
      }
    ],
    "id": "InstanceId"
  },
  "aws.ssm-parameter": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Id"
      }
    ],
    "id": "Name"
  },
  "aws.ssm-patch-group": {
    "columns": [
      {
        "type": "string",
        "field": "PatchGroup",
        "headerName": "Id"
      }
    ],
    "id": "PatchGroup"
  },
  "aws.ssm-session-manager": {
    "columns": [
      {
        "type": "string",
        "field": "SessionId",
        "headerName": "Id"
      }
    ],
    "id": "SessionId"
  },
  "aws.step-machine": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      },
      {
        "type": "time",
        "field": "creationDate",
        "headerName": "Creation Date"
      }
    ],
    "id": "stateMachineArn"
  },
  "aws.storage-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "GatewayARN",
        "headerName": "Id"
      }
    ],
    "id": "GatewayARN"
  },
  "aws.streaming-distribution": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "string",
        "field": "PriceClass",
        "headerName": "Price Class"
      },
      {
        "type": "time",
        "field": "LastModifiedTime",
        "headerName": "Last Modified Time"
      },
      {
        "type": "boolean",
        "field": "Enabled",
        "headerName": "Enabled"
      }
    ],
    "id": "Id"
  },
  "aws.subnet": {
    "columns": [
      {
        "type": "string",
        "field": "SubnetId",
        "headerName": "Id"
      }
    ],
    "id": "SubnetId"
  },
  "aws.support-case": {
    "columns": [
      {
        "type": "string",
        "field": "caseId",
        "headerName": "Id"
      }
    ],
    "id": "caseId"
  },
  "aws.swf-domain": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Id"
      }
    ],
    "id": "name"
  },
  "aws.timestream-database": {
    "columns": [
      {
        "type": "string",
        "field": "Arn",
        "headerName": "Id"
      }
    ],
    "id": "Arn"
  },
  "aws.timestream-influxdb": {
    "columns": [
      {
        "type": "string",
        "field": "arn",
        "headerName": "Id"
      }
    ],
    "id": "arn"
  },
  "aws.timestream-influxdb-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.timestream-table": {
    "columns": [
      {
        "type": "string",
        "field": "Arn",
        "headerName": "Id"
      }
    ],
    "id": "Arn"
  },
  "aws.transfer-connector": {
    "columns": [
      {
        "type": "string",
        "field": "ConnectorId",
        "headerName": "Id"
      }
    ],
    "id": "ConnectorId"
  },
  "aws.transfer-server": {
    "columns": [
      {
        "type": "string",
        "field": "ServerId",
        "headerName": "Id"
      }
    ],
    "id": "ServerId"
  },
  "aws.transfer-user": {
    "columns": [
      {
        "type": "string",
        "field": "UserName",
        "headerName": "Id"
      }
    ],
    "id": "UserName"
  },
  "aws.transfer-web-app": {
    "columns": [
      {
        "type": "string",
        "field": "WebAppId",
        "headerName": "Id"
      }
    ],
    "id": "WebAppId"
  },
  "aws.transit-attachment": {
    "columns": [
      {
        "type": "string",
        "field": "TransitGatewayAttachmentId",
        "headerName": "Transit Gateway Attachment Id"
      },
      {
        "type": "string",
        "field": "TransitGatewayId",
        "headerName": "Transit Gateway Id"
      },
      {
        "type": "string",
        "field": "TransitGatewayOwnerId",
        "headerName": "Transit Gateway Owner Id"
      },
      {
        "type": "string",
        "field": "ResourceType",
        "headerName": "Resource Type"
      },
      {
        "type": "string",
        "field": "ResourceId",
        "headerName": "Resource Id"
      },
      {
        "type": "string",
        "field": "ResourceOwnerId",
        "headerName": "Resource Owner Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "Association.State",
        "headerName": "Association State"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      }
    ],
    "id": "TransitGatewayAttachmentId"
  },
  "aws.transit-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "TransitGatewayId",
        "headerName": "Transit Gateway Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "time",
        "field": "CreationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      }
    ],
    "id": "TransitGatewayId"
  },
  "aws.user-pool": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.vpc": {
    "columns": [
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "CidrBlock",
        "headerName": "Cidr Block"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "DhcpOptionsId",
        "headerName": "Dhcp Options Id"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      },
      {
        "type": "boolean",
        "field": "IsDefault",
        "headerName": "Is Default"
      }
    ],
    "id": "VpcId"
  },
  "aws.vpc-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "VpcEndpointId",
        "headerName": "Vpc Endpoint Id"
      },
      {
        "type": "time",
        "field": "CreationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "VpcEndpointType",
        "headerName": "Vpc Endpoint Type"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "Vpc Id"
      },
      {
        "type": "string",
        "field": "ServiceName",
        "headerName": "Service Name"
      },
      {
        "type": "string",
        "field": "OwnerId",
        "headerName": "Owner Id"
      }
    ],
    "id": "VpcEndpointId"
  },
  "aws.vpc-endpoint-service-configuration": {
    "columns": [
      {
        "type": "string",
        "field": "ServiceId",
        "headerName": "Id"
      }
    ],
    "id": "ServiceId"
  },
  "aws.vpc-lattice-listener": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.vpc-lattice-service": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.vpc-lattice-service-network": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.vpc-lattice-service-network-association": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.vpc-lattice-target-group": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      }
    ],
    "id": "id"
  },
  "aws.vpn-connection": {
    "columns": [
      {
        "type": "string",
        "field": "VpnConnectionId",
        "headerName": "Vpn Connection Id"
      },
      {
        "type": "string",
        "field": "VpnGatewayId",
        "headerName": "Vpn Gateway Id"
      },
      {
        "type": "string",
        "field": "CustomerGatewayId",
        "headerName": "Customer Gateway Id"
      },
      {
        "type": "string",
        "field": "TransitGatewayId",
        "headerName": "Transit Gateway Id"
      },
      {
        "type": "string",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "Category",
        "headerName": "Category"
      }
    ],
    "id": "VpnConnectionId"
  },
  "aws.vpn-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "VpnGatewayId",
        "headerName": "Id"
      }
    ],
    "id": "VpnGatewayId"
  },
  "aws.waf": {
    "columns": [
      {
        "type": "string",
        "field": "WebACLId",
        "headerName": "Id"
      }
    ],
    "id": "WebACLId"
  },
  "aws.waf-regional": {
    "columns": [
      {
        "type": "string",
        "field": "WebACLId",
        "headerName": "Id"
      }
    ],
    "id": "WebACLId"
  },
  "aws.wafv2": {
    "columns": [
      {
        "type": "string",
        "field": "Id",
        "headerName": "Id"
      }
    ],
    "id": "Id"
  },
  "aws.workspaces": {
    "columns": [
      {
        "type": "string",
        "field": "WorkspaceId",
        "headerName": "Workspace Id"
      },
      {
        "type": "string",
        "field": "DirectoryId",
        "headerName": "Directory Id"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "VolumeEncryptionKey",
        "headerName": "Volume Encryption Key"
      },
      {
        "type": "boolean",
        "field": "UserVolumeEncryptionEnabled",
        "headerName": "User Volume Encryption Enabled"
      },
      {
        "type": "boolean",
        "field": "RootVolumeEncryptionEnabled",
        "headerName": "Root Volume Encryption Enabled"
      },
      {
        "type": "number",
        "field": "WorkspaceProperties.RunningModeAutoStopTimeoutInMinutes",
        "headerName": "Running Mode Auto Stop Timeout In Minutes"
      },
      {
        "type": "string",
        "field": "ComputerName",
        "headerName": "Computer Name"
      }
    ],
    "id": "WorkspaceId"
  },
  "aws.workspaces-bundle": {
    "columns": [
      {
        "type": "string",
        "field": "BundleId",
        "headerName": "Id"
      }
    ],
    "id": "BundleId"
  },
  "aws.workspaces-directory": {
    "columns": [
      {
        "type": "string",
        "field": "DirectoryId",
        "headerName": "Id"
      }
    ],
    "id": "DirectoryId"
  },
  "aws.workspaces-image": {
    "columns": [
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Id"
      }
    ],
    "id": "ImageId"
  },
  "aws.workspaces-web": {
    "columns": [
      {
        "type": "string",
        "field": "portalArn",
        "headerName": "Id"
      }
    ],
    "id": "portalArn"
  },
  "aws.xray-group": {
    "columns": [
      {
        "type": "string",
        "field": "GroupName",
        "headerName": "Id"
      }
    ],
    "id": "GroupName"
  },
  "aws.xray-rule": {
    "columns": [
      {
        "type": "string",
        "field": "RuleName",
        "headerName": "Id"
      }
    ],
    "id": "RuleName"
  }
}
